<template>
  <div>
    <h3 class="title-head">RFID Enrollment</h3>
    <p class="kiosk-status">
      <template v-if="status == 'optionalForAllAndNoKioskSelected'">
        RFID enrollment instructions were successfully “Sent” to the selected
        users.
      </template>

      <template v-else-if="status == 'mandatoryForAll'">
        Please check the {{ kiosksName }}
        {{
          selectedKiosks && selectedKiosks.length == 1 ? "kiosk" : "kiosks"
        }}
        to get the “Printed” badges for the selected users.
      </template>

      <template v-else>
        RFID enrollment instructions were successfully “Sent”. Please check the
        {{ kiosksName }}
        {{
          selectedKiosks && selectedKiosks.length == 1 ? "kiosk" : "kiosks"
        }}
        to get the “Printed” badges.
      </template>
    </p>
    <div class="h-line"></div>
    <div class="okay-con d-flex align-items-center justify-content-center">
      <button
        class="submit-btn btn btn-primary"
        style="margin-inline-end: 0px"
        @click="usersRedirect"
      >
        Okay
      </button>
    </div>
    <!-- <button @click="usersRedirect">Okay</button> -->
  </div>
</template>

<script>
export default {
  props: {
    status: {
      type: String,
      default: "",
    },
    selectedKiosks: {
      type: Array,
      default: () => [""],
    },
  },
  data() {
    return {
      kiosksName: "",
    };
  },
  beforeMount() {
    this.kiosksName = this.selectedKiosks
      ?.map((kiosk) => `"${kiosk.name}"`)
      .join(", ");
  },
  methods: {
    usersRedirect() {
      this.$router.push({ name: "users" });
    },
  },
};
</script>
<style lang="scss">
div#result-modal {
  // background: #F3F3F3;
  div#result-modal___BV_modal_content_ {
    background: #ffffff;
    border-radius: 26px;
    width: 579px;
    margin-top: 150px;
    margin-bottom: 100px;
    h3.title-head {
      font-weight: 700;
      font-size: 16px;
      line-height: 20px;
      margin-bottom: 40px;
      color: #000000;
    }
    p.kiosk-status {
      font-weight: 700;
      font-size: 16px;
      line-height: 25px;
      margin: auto;
      text-align: center;
      width: fit-content;
      color: #787878;
    }
    p.main-content {
      font-weight: 400;
      font-size: 16px;
      line-height: 28px;
      /* or 178% */

      text-align: center;
      letter-spacing: 0.25px;
      margin: auto;
      /* #939393 */
      width: 469px;
      color: #939393;
    }
    .h-line {
      // width: 488px;
      height: 1px;
      background: #707070;
      opacity: 0.15;
      margin: 40px auto 20px auto;
    }
    button.submit-btn.btn.btn-primary {
      width: 112px;
      height: 33px;

      font-weight: 400;
      font-size: 16px;
      line-height: 19px;
      text-align: center;
      display: flex;
      margin-inline-end: 31px;
      align-items: center;
      justify-content: center;
      border-radius: 18px;
      color: #ffffff;
    }
    button.btn.btn-outline-danger {
      width: 112px;
      height: 33px;

      font-weight: 400;
      font-size: 16px;
      line-height: 19px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 18px;
    }
    // .buttons-con{
    //   display: flex;
    // align-items: center;
    // justify-content: center;
    // }
  }
}
</style>
